import { PARTICIPANT_SET_INFORMATION } from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';
import Host from '@app/store/Host';

import { fetchParticipantStatusSuccess, ParticipantAction } from '../actions';

export type HostState = Host | null;

const initialState: HostState = null;

export default function reducer(
  state: HostState = initialState,
  action: ParticipantAction | ContractAuthenticationAction
): HostState {
  switch (action.type) {
    /**
     * FIXME: 현재 대면서명에서 host 정보를 selector를 통해 전해주고 있어 유지할 필요가 있습니다.
     * 그러나 host state만의 예외적인 동작이므로 예측하기 어렵고, 추후 개선할 수 있습니다.
     */
    // case CONTRACT_AUTHENTICATION_INITIALIZE:
    // return initialState;
    case fetchParticipantStatusSuccess.type:
    case PARTICIPANT_SET_INFORMATION:
      return action.payload.host || state;

    default:
      return state;
  }
}
